import { notification, Select } from "antd";
import AccessControl from "components/common/AccessControl/accessControl";
import ManageAccess from "components/common/ManageAccess/manageAccess";
import { ENTITY_TYPE, ROLE } from "constants/phase";
import { Field, Form, Formik } from "formik";
import { getEntityType } from "helpers";
import React, { useEffect, useState } from "react";
import { useOutletContext } from "react-router-dom";
import { organizationProfileCategory, organizationStreamLevelRistriction } from "utils/validations";

const Operations = (props) => {
  const {
    id,
    contentSports,
    setContentSports,
    getAllSports,
    allSports,
    assignCategoryToOrganization,
    entityConfig,
    updateClientSetting,
    getEntityDetails,
  } = props;
  const [initialValues, setInitialValues] = useState({ contentSports: [] });
  const [initialStreamValues, setInitialStreamValues] = useState({
    maxVideoProcessDuration: 0,
    maxVideoDownloadDuration: 0,
    maxStreamProcessingLimit: 0,
    maxLiveCutEditorDuration: 1,
    maxUploadToCloudClipDuration: 0,
    maxNumberOfUsers: 3,
    maxVideoDownloadDurationAllStream: 0,
  });
  const { user, entityId, currentRole } = useOutletContext();
  const { Option } = Select;

  useEffect(() => {
    getAllSports();
  }, [user]);
  useEffect(() => {
    if (entityConfig) {
      setInitialStreamValues({
        ...initialStreamValues,
        maxVideoDownloadDuration: entityConfig?.limitation?.maxVideoDownloadDuration || 0,
        maxVideoProcessDuration: entityConfig?.limitation?.maxVideoProcessDuration || 0,
        maxStreamProcessingLimit: entityConfig?.streamProcessLimit || 10,
        maxLiveCutEditorDuration: entityConfig?.limitation?.maxLiveCutEditorDuration || 1,
        maxUploadToCloudClipDuration: entityConfig.limitation?.maxUploadToCloudClipDuration || 0,
        maxNumberOfUsers: entityConfig?.maxNumberOfUsers || 3,
      });
    }
  }, [entityConfig]);
  useEffect(() => {
    setInitialValues({
      ...initialValues,
      contentSports: contentSports, // Set the default value here
    });
  }, [contentSports]);

  const handleSubmit = async (values) => {
    const categoryId = (await allSports) && allSports?.filter((data) => values?.contentSports.includes(data?.name));
    const { value } = await assignCategoryToOrganization({
      categoryIds: categoryId.map(({ _id }) => _id),
      entityId: id,
    });
    if (value?.success) {
      notification["success"]({ message: value?.message });
    }
  };

  const handleContentCategory = (e, setFieldValue) => {
    setFieldValue("contentSports", e);
    setContentSports(e);
  };

  const handleLimitSubmit = async (values) => {
    const payload = {
      entityId: id,
      limitation: {
        maxVideoDownloadDuration: values.maxVideoDownloadDuration,
        maxVideoProcessDuration: values.maxVideoProcessDuration,
        maxLiveCutEditorDuration: values.maxLiveCutEditorDuration,
        maxUploadToCloudClipDuration: values.maxUploadToCloudClipDuration,
      },
      streamProcessLimit: values?.maxStreamProcessingLimit,
      maxNumberOfUsers: values?.maxNumberOfUsers,
    };
    const { value } = await updateClientSetting(payload);
    if (value?.status) {
      notification["success"]({ message: value?.message });
      getEntityDetails();
    } else {
      notification["error"]({ message: value?.message });
    }
  };
  return (
    <div className="right-container--op">
      <ManageAccess value={currentRole === ROLE.SUPER_ADMIN}>
        <div>
          <div className="border-block profile-table-container mt-4" id="privileges">
            <div className="inner-table-container">
              <Formik
                initialValues={initialValues}
                enableReinitialize
                validationSchema={organizationProfileCategory}
                onSubmit={handleSubmit}
              >
                {({ errors, touched, values, setFieldValue, isSubmitting, submitForm }) => (
                  <Form>
                    <div className="table-contaier-div">
                      <div className="field-items mb-4">
                        <label>Content Category</label>
                        <Select
                          className="custom-ant-select"
                          mode="multiple"
                          style={{ width: "100%" }}
                          placeholder="Select Category"
                          dropdownStyle={{ zIndex: 2000 }}
                          value={values?.contentSports}
                          onChange={(e) => {
                            handleContentCategory(e, setFieldValue);
                          }}
                          disabled={entityId === id}
                        >
                          {allSports &&
                            allSports.map((sport, id) => (
                              <Option key={sport._id} value={sport?.name}>
                                <div className="demo-option-label-item">{sport?.displayName || sport?.name}</div>
                              </Option>
                            ))}
                        </Select>
                        {touched.contentSports && errors.contentSports && (
                          <div className="invalid-feedback">{errors.contentSports}</div>
                        )}
                        <label></label>
                      </div>

                      <div className="button-container">
                        <AccessControl code="edit_team" page="organization-profile">
                          {/* <ManageAccess value={data?.organizationId == entityId}> */}
                          <button type="submit" className="btn btn-primary" disabled={entityId == id}>
                            Update
                          </button>
                          {/* </ManageAccess> */}
                        </AccessControl>
                      </div>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </div>
        </div>
      </ManageAccess>
      <>
        <Formik
          initialValues={initialStreamValues}
          enableReinitialize
          validationSchema={organizationStreamLevelRistriction}
          onSubmit={handleLimitSubmit}
        >
          {({ errors, touched, values, setFieldValue, isSubmitting, submitForm }) => (
            <Form>
              {entityConfig?.permissions?.isProcessingLimit && getEntityType(id) === ENTITY_TYPE.WORKSPACES ? (
                <div className="agreementTerms--container mt-5">
                  <div className="title-block--op">
                    <h5>Stream Level Restrictions</h5>
                  </div>
                  <div className="row">
                    <div className="col-md-4">
                      <div className="at--block-items">
                        <p>Maximum video creation duration (seconds)</p>
                        <Field
                          type="number"
                          onChange={(e) => {
                            const value = isNaN(parseInt(e.target.value)) ? null : parseInt(e.target.value);
                            setFieldValue("maxVideoProcessDuration", value); // Set field value using Formik setFieldValue
                          }}
                          value={values?.maxVideoProcessDuration}
                          name="maxVideoProcessDuration"
                          disabled={currentRole !== ROLE.SUPER_ADMIN}
                          className="form-control filters-search-control"
                        />
                        {touched.maxVideoProcessDuration && errors.maxVideoProcessDuration && (
                          <div className="invalid-feedback">{errors.maxVideoProcessDuration}</div>
                        )}
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="at--block-items">
                        <p>Maximum download duration (seconds)</p>
                        <Field
                          type="number"
                          onChange={(e) => {
                            const value = isNaN(parseInt(e.target.value)) ? null : parseInt(e.target.value);
                            setFieldValue("maxVideoDownloadDuration", value); // Set field value using Formik setFieldValue
                          }}
                          name="maxVideoDownloadDuration"
                          disabled={currentRole !== ROLE.SUPER_ADMIN}
                          value={values?.maxVideoDownloadDuration}
                          className="form-control filters-search-control"
                        />
                        {touched.maxVideoDownloadDuration && errors.maxVideoDownloadDuration && (
                          <div className="invalid-feedback">{errors.maxVideoDownloadDuration}</div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              ) : null}
              <div className="agreementTerms--container mt-5">
                <div className="title-block--op">
                  <h5>Agreement & terms</h5>
                </div>
                <div className="row">
                  {entityConfig?.permissions?.isUploadToCloudDuration ? (
                    <div className="col-md-4">
                      <div className="at--block-items">
                        Upload To Cloud Clip Restrictions(16:9)
                        <Field
                          type="number"
                          onChange={(e) => {
                            const value = isNaN(parseInt(e.target.value)) ? null : parseInt(e.target.value);
                            setFieldValue("maxUploadToCloudClipDuration", value); // Set field value using Formik setFieldValue
                          }}
                          disabled={currentRole !== ROLE.SUPER_ADMIN}
                          value={values?.maxUploadToCloudClipDuration}
                          className="form-control filters-search-control"
                          name="maxUploadToCloudClipDuration"
                        />
                        {touched.maxUploadToCloudClipDuration && errors.maxUploadToCloudClipDuration && (
                          <div className="invalid-feedback">{errors.maxUploadToCloudClipDuration}</div>
                        )}
                      </div>
                    </div>
                  ) : null}
                  {entityConfig?.permissions?.liveCutEditor ? (
                    <div className="col-md-4">
                      <div className="at--block-items">
                        Live Editor Cut
                        <Field
                          type="number"
                          onChange={(e) => {
                            const value = isNaN(parseInt(e.target.value)) ? null : parseInt(e.target.value);
                            setFieldValue("maxLiveCutEditorDuration", value); // Set field value using Formik setFieldValue
                          }}
                          disabled={currentRole !== ROLE.SUPER_ADMIN}
                          value={values?.maxLiveCutEditorDuration}
                          className="form-control filters-search-control"
                          name="maxLiveCutEditorDuration"
                        />
                        {touched.maxLiveCutEditorDuration && errors.maxLiveCutEditorDuration && (
                          <div className="invalid-feedback">{errors.maxLiveCutEditorDuration}</div>
                        )}
                      </div>
                    </div>
                  ) : null}
                  <div className="col-md-4">
                    <div className="at--block-items">
                      Maximum number of concurrent streams
                      <Field
                        type="number"
                        onChange={(e) => {
                          const value = isNaN(parseInt(e.target.value)) ? null : parseInt(e.target.value);
                          setFieldValue("maxStreamProcessingLimit", value); // Set field value using Formik setFieldValue
                        }}
                        disabled={currentRole !== ROLE.SUPER_ADMIN}
                        value={values?.maxStreamProcessingLimit}
                        className="form-control filters-search-control"
                        name="maxStreamProcessingLimit"
                      />
                      {touched.maxStreamProcessingLimit && errors.maxStreamProcessingLimit && (
                        <div className="invalid-feedback">{errors.maxStreamProcessingLimit}</div>
                      )}
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="at--block-items">
                      <p>Maximum number of users</p>
                      {/* <Field type="number" disabled={true} value={70} className="form-control filters-search-control" /> */}
                      <Field
                        type="number"
                        onChange={(e) => {
                          const value = isNaN(parseInt(e.target.value)) ? null : parseInt(e.target.value);
                          setFieldValue("maxNumberOfUsers", value); // Set field value using Formik setFieldValue
                        }}
                        disabled={currentRole !== ROLE.SUPER_ADMIN}
                        value={values?.maxNumberOfUsers}
                        className="form-control filters-search-control"
                        name="maxNumberOfUsers"
                      />
                      {touched.maxNumberOfUsers && errors.maxNumberOfUsers && (
                        <div className="invalid-feedback">{errors.maxNumberOfUsers}</div>
                      )}
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="at--block-items">
                      Maximum number of workspaces
                      <Field type="number" disabled={true} value={70} className="form-control filters-search-control" />
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="at--block-items">
                      Maximum number of clips per stream
                      <Field type="number" disabled={true} value={70} className="form-control filters-search-control" />
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="at--block-items">
                      Maximum number of Highlights per stream
                      <Field type="number" disabled={true} value={70} className="form-control filters-search-control" />
                    </div>
                  </div>
                </div>
              </div>

              <div className="button-container">
                <ManageAccess value={currentRole === ROLE.SUPER_ADMIN}>
                  <button type="submit" className="btn btn-primary">
                    Update
                  </button>
                </ManageAccess>
              </div>
            </Form>
          )}
        </Formik>
      </>
    </div>
  );
};

export default Operations;
